<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2022-05-24 14:20:49
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2022-08-01 14:58:23
 * @FilePath: \partner.chaoyongtuan.com\src\views\talentCRM\components\detailDrawer\components\talentDataTab\components\coreCard\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="core-card">
		<div class="label">核心数据</div>
		<div class="content">
			<div class="item">
				<img src="./img/live_experience_MSGap.png" alt="" />
				<div class="ml-12">
					<div class="fz-18 yx-color-text-primary">{{ cronData.live_experience_MSGap || '--' }}</div>
					<div class="fz-12 yx-color-text-regular">直播带货经验</div>
				</div>
			</div>
			<div class="item">
				<img src="./img/live_count_90.png" alt="" />
				<div class="ml-12">
					<div class="fz-14 yx-color-text-primary"
						><span class="fz-20 font-bold">{{ cronData.live_count_90 || '--' }}</span
						>次</div
					>
					<div class="fz-12 yx-color-text-regular">近90天直播带货次数</div>
				</div>
			</div>
			<div class="item">
				<img src="./img/avg_price.png" alt="" />
				<div class="ml-12">
					<price-text v-if="cronData.avg_price" :price="cronData.avg_price" :high-size="20" />
					<div v-else class="fz-20 font-bold">--</div>
					<div class="fz-12 yx-color-text-regular">商品均价</div>
				</div>
			</div>
			<div class="item">
				<img src="./img/sales.png" alt="" />
				<div class="ml-12">
					<div class="fz-14 yx-color-text-primary"
						><span class="fz-20 font-bold">{{ cronData.salesVolume || '--' }}</span></div
					>
					<div class="fz-12 yx-color-text-regular">近90天销量</div>
				</div>
			</div>
			<div class="item">
				<img src="./img/sales_volume.png" alt="" />
				<div class="ml-12">
					<price-text v-if="cronData.sales" :price="cronData.sales" :high-size="20" />
					<div v-else class="fz-20 font-bold">--</div>
					<div class="fz-12 yx-color-text-regular">近90天销售额</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import priceText from '@/components/common/priceText';

export default {
	name: 'coreCard',
	components: {
		priceText,
	},
	props: {
		cronData: {
			type: Object,
			default: _ => ({}),
		},
	},
};
</script>

<style lang="less" scoped>
.core-card {
	padding-bottom: 32px;
	border-bottom: 1px solid #eee;
	margin-bottom: 12px;
	.label {
		font-size: 16px;
		font-weight: 700;
		color: #333;
	}
	.content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 28px;
		.item {
			display: flex;
			img {
				width: 36px;
				height: 36px;
			}
			& + .item {
				// margin-left: 80px;
			}
		}
	}
}
</style>
